module.exports = __webpack_public_path__ + "static/media/person-use-phone.982e3cca.png";